<template>
  <section
    id="about-me-section"
    class="z-10 relative bg-[#0B0B0A] shadow-2xl sm:mt-0 rounded-b-3xl overflow-y-clip text-flax-smoke-200 will-change-auto common-padding"
  >
    <div class="grid grid-cols-12 md:column-gap">
      <div class="md:col-span-4 overflow-hidden hide-on-mobile">
        <svg
          id="down-arrow-2"
          stroke="currentColor"
          fill="none"
          stroke-width="1.25"
          viewBox="6 6 12 12"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="m-0 p-0 size-20 -translate-x-full hide-on-mobile"
          height="1em"
          width="1em"
          xmlns="http://www.w3.org/2000/svg"
        >
          <line x1="7" y1="7" x2="17" y2="17"></line>
          <polyline points="17 7 17 17 7 17"></polyline>
        </svg>
      </div>

      <h3
        id="little-bit-about-me"
        v-html="aboutMe"
        class="col-span-full md:col-span-8 md:col-start-6 font-extrabold uppercase leading-none heading-1-alt lg:heading-1 section-heading"
      ></h3>
    </div>

    <div class="grid grid-cols-12 mt-6 padding-y md:column-gap">
      <div
        class="content-end col-span-full md:col-span-4 rounded-lg pointer-events-none select-none"
      >
        <img
          :src="profile2"
          class="brightness-90 grayscale rounded-lg object-cover object-top aspect-[1/1.5] mix-blend-screen"
          alt=""
        />
      </div>
      <div class="col-span-11 md:col-span-8 md:col-start-6 mt-10">
        <p
          class="relative w-full max-w-[40ch] font-medium text-balance leading-snug heading-4"
        >
        A full-stack web developer leveraging custom themes, plugins, and modern tools to deliver end-to-end solutions that drive real value for your business.
        </p>

        <div
          class="flex justify-start gap-10 sm:gap-20 mt-[5%] text-flax-smoke-300"
        >
          <p class="text-flax-smoke-300/85 text-center text-nowrap heading-6">
            ( ABOUT ME )
          </p>
          <p class="w-full sm:max-w-[40ch] font-fancy text-balance heading-6">
    Creating high performing, user-friendly web experiences is at the core of what I do. I combine clean code, attention to detail, and user-focused design to ensure each project delivers both function and a feel-good experience.

When I’m not coding or optimizing websites, I enjoy sharing my freelance journey on <i>𝕏</i>, running my t-shirt business, or exploring new creative projects.
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
  import {
    animateSplitText,
    xToZero,
    animateAboutMeSectionLeave,
  } from '@/animations';
  import { profile2 } from '@/assets/images';
  import { textSplitterIntoChar } from '@/functions';
  import { onBeforeMount, onMounted, ref } from 'vue';

  const aboutMe = ref('ٍSelected Projects /');

  // const initialPath = ref(`M0 0H${width.value}  V${height.value} H0 Z`);
  // const targetPath = ref(
  //   `M0 0H${width.value}L${width.value * 0.9} ${height.value}H${width.value * 0.1}L0 0Z`,
  // );

  onBeforeMount(() => {
    aboutMe.value = textSplitterIntoChar(
      'Full Stack Web Developer',
      true,
      true,
    );
  });

  onMounted(() => {
    animateSplitText(
      '#little-bit-about-me .letters',
      '#little-bit-about-me',
      1,
      0.01,
      0,
      () => {
        xToZero('#down-arrow-2');
      },
    );

    animateAboutMeSectionLeave('#about-me-section');
  });
</script>
